import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#2d5f5d]/5 border-t border-[#2d5f5d]/10 mt-auto" data-id="element-2">
      <div className="max-w-4xl mx-auto px-6 py-8" data-id="element-3">
        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-6" data-id="element-4">
          <a href="https://www.californiapsychics.com/about/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-sm text-[#2d5f5d] hover:text-[#d4af37] transition-colors underline" data-id="element-5">
            Privacy Policy
          </a>
          <span className="text-[#5a7c7a]" data-id="element-6">•</span>
          <a href="https://www.californiapsychics.com/about/terms-of-use" target="_blank" rel="noopener noreferrer" className="text-sm text-[#2d5f5d] hover:text-[#d4af37] transition-colors underline" data-id="element-7">
            Terms of Use
          </a>
          <span className="text-[#5a7c7a]" data-id="element-8">•</span>
          <a href="https://www.californiapsychics.com/contact" target="_blank" rel="noopener noreferrer" className="text-sm text-[#2d5f5d] hover:text-[#d4af37] transition-colors underline" data-id="element-9">
            Contact Us
          </a>
        </div>

        {/* Affiliate Disclosure */}
        <div className="text-center mb-4" data-id="element-10">
          <p className="text-xs text-[#5a7c7a] leading-relaxed max-w-2xl mx-auto" data-id="element-11">
            <strong className="text-[#2d5f5d]" data-id="element-12">Affiliate Disclosure:</strong> We
            are affiliates of California Psychics. We may earn a commission when
            you use our links to visit their site. We are not directly
            affiliated with or endorsed by California Psychics, and all opinions
            expressed are our own.
          </p>
        </div>

        {/* Facebook Disclaimer */}
        <div className="text-center" data-id="element-13">
          <p className="text-xs text-[#5a7c7a] leading-relaxed max-w-2xl mx-auto" data-id="element-14">
            This site is not affiliated with or endorsed by Facebook (Meta
            Platforms, Inc.). Facebook® is a registered trademark of Facebook,
            Inc. All other trademarks are the property of their respective
            owners. Content and opinions expressed here are those of the site
            owner and not representative of Facebook.
          </p>
        </div>
      </div>
    </footer>;
}